import React, { Component, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.css';
import { url } from '../../weburl';
import axios from 'axios'
import { useState } from 'react';
import { dogUrlGenerator } from '../../../util.js/dogUrlGenerator';
export const AdminDogsDetailSearch = (props) => {

    const [search_input, setSearchInput] = useState('')
    const [search_dogs, setSearchDogs] = useState({})
    const navigate = useNavigate()
    useEffect(() => {
        axios
            .get(`${url}api/dogs/search/${search_input}`)
            .then((res) => {
                if (res.data) {
                    if (props.customDogsArray) {
                        props.setSearchDogs(res.data)
                        console.log('setting dogs from props')
                    }
                    else {
                        setSearchDogs(res.data)

                    }
                }

                // console.log(search_dogs)
                !props.customDogsArray && displayResults()
            }
            )
            .catch((err) => console.log(err))
    }, [search_input])

    const onInputChange = (e) => {
        setSearchInput(e.target.value)


    }

    const buttonClick = (e) => {
        e.preventDefault()
        props.onSearchClick()
    }


    const displayResults = () => {
        return Object.keys(search_dogs).map((item) => {
            console.log(console.log(search_dogs[item]['name']))

            return <div className='container'>
                <button className='btn  border_left_yellow  box_shadow w-100  mb-4 text-dark' name='sire'
                    value={search_dogs[item]['id']}
                    onClick={e => {
                        navigate(`/admin/dogs-detail/${search_dogs[item]['id']}/${dogUrlGenerator(search_dogs[item][
                            'name'
                        ])}`)
                        setSearchInput(search_dogs[item]['name'])
                        setSearchDogs({})
                        console.log('search input', search_input)
                    }}
                >         <div className='row align-items-center justify-content-center py-0'>

                        <div className='col-md-2'>
                            <img
                                src={`https://res.cloudinary.com/daurieb51/image/upload/v1642082142/${search_dogs[item]['public_id']}.png`}
                                className='rounded w-100 ' alt="" />
                        </div>
                        <div className='col-md-5 font-weight-bold py-5 py-md-0'> {search_dogs[item]['name']}</div>
                    </div>

                </button>
            </div>
        })
    }
    return (


        <div className='container-fluid'>
            <div className='row align-items-center justify-content-center'>
                <input type='search'
                    class='search_input px-2 py-2'
                    name={props.name} value={search_input}
                    onChange={(e) => onInputChange(e)}
                    placeholder='Search for dog'></input>


            </div>
            <div className='row align-items-center justify-content-center '>
                <div className='col-lg-12 mt-4'>
                    {displayResults()}
                </div>

            </div>

        </div>



    )
}

